import { ContentType } from 'library/ts/model/enums/content/ContentType';
import { PlayerAdapterEvent } from 'library/ts/player/adapter/events/PlayerAdapterEvent';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { VideoInterruptType } from 'tag/ts/tag/model/enums/VideoInterruptType';
export class VideoAPIInterrupt extends AbstractTagClass {
    constructor(argument) {
        super({
            ...argument,
            name: 'VideoAPIInterrupt'
        });
        this.tagEventsHandler(this.#onTagEvent, [
            TagEvent.ON_API_LOAD_VIDEO_REQUEST,
            TagEvent.ON_PLAYER_EVENT,
            TagEvent.ON_TAG_PLAYER_STOP_SUCCESS
        ]);
    }
    #executeInterruptAfterAd = false;
    #interruptCallback;
    #interrupted = false;
    get interrupted() {
        return this.#interrupted;
    }
    #stopPlayer = () => {
        this.#interrupted = true;
        this.utils.Delay.delay().then(() => {
            this.tag.dispatchTagEvent(this.tag.getTagEventVO(TagEvent.ON_TAG_PLAYER_STOP_REQUEST, this.tag, undefined, this, this.name));
        });
    };
    #onPlayerEvent = (event) => {
        switch (event.type) {
            case PlayerAdapterEvent.CONTENT_SEGMENT_START:
            case PlayerAdapterEvent.CONTENT_START:
                if (this.#executeInterruptAfterAd === true) {
                    this.#stopPlayer();
                }
                break;
        }
    };
    #onTagEvent = (event) => {
        switch (event.type) {
            case TagEvent.ON_API_LOAD_VIDEO_REQUEST:
                this.#interrupted = false;
                break;
            case TagEvent.ON_PLAYER_EVENT:
                this.#onPlayerEvent(event.data.playerAdapterEvent);
                break;
            case TagEvent.ON_TAG_PLAYER_STOP_SUCCESS:
                if (this.utils.Type.isFunction(this.#interruptCallback)) {
                    this.#interruptCallback();
                }
                break;
        }
    };
    interrupt = (argument) => {
        this.#interruptCallback = argument?.callback;
        switch (argument?.reason) {
            case VideoInterruptType.STOP_CONTENT_AFTER_AD:
                if (this?.tag?.controller?.playerManager?.contentType === ContentType.AD) {
                    this.#executeInterruptAfterAd = true;
                }
                else {
                    this.#stopPlayer();
                }
                break;
            case VideoInterruptType.STOP_CONTENT_MULTI_STREAM:
                this.#stopPlayer();
                break;
            default:
                break;
        }
    };
}
